export { default } from './Compartir';
